import { render, staticRenderFns } from "./TiktokIframe.vue?vue&type=template&id=0a73c57e&scoped=true&"
import script from "./TiktokIframe.vue?vue&type=script&lang=js&"
export * from "./TiktokIframe.vue?vue&type=script&lang=js&"
import style0 from "./TiktokIframe.vue?vue&type=style&index=0&id=0a73c57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a73c57e",
  null
  
)

component.options.__file = "TiktokIframe.vue"
export default component.exports